import { User } from "@istari/istari-client";
import { useQuery } from "@tanstack/react-query";

import { userQueryOptions } from "./user-query-options";
import { userToInternalUser } from "./user-to-internal-user";

// Stable reference: React Query only memoizes `select` when the function identity is unchanged
// across renders, and this query is mounted once per creator-name consumer (e.g. every versions
// row) — an inline closure would re-map the whole tenant list on each render of each observer.
const selectInternalUsers = (users: User[]) => users.map(userToInternalUser);

export const useUsers = (options?: { enabled?: boolean }) =>
  useQuery({
    ...userQueryOptions.all(),
    select: selectInternalUsers,
    enabled: options?.enabled,
  });
